import { render, staticRenderFns } from "./contactSendsPattern.vue?vue&type=template&id=60c70831&scoped=true"
import script from "./contactSendsPattern.vue?vue&type=script&lang=js"
export * from "./contactSendsPattern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c70831",
  null
  
)

export default component.exports